var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.25C3.99577 15.25 0.75 12.0042 0.75 8C0.75 3.99577 3.99577 0.75 8 0.75C12.0042 0.75 15.25 3.99577 15.25 8C15.25 12.0042 12.0042 15.25 8 15.25ZM8 14.1346C11.388 14.1346 14.1346 11.388 14.1346 8C14.1346 4.61202 11.388 1.86538 8 1.86538C4.61202 1.86538 1.86538 4.61202 1.86538 8C1.86538 11.388 4.61202 14.1346 8 14.1346ZM6.41392 6.7279H8.67983V11.6077H9.58608V12.0606H6.41392V11.6077H7.32017V7.18019H6.41392V6.72735V6.7279ZM8 5.75194C7.75965 5.75194 7.52914 5.65646 7.35918 5.48651C7.18923 5.31655 7.09375 5.08604 7.09375 4.84569C7.09375 4.60534 7.18923 4.37483 7.35918 4.20488C7.52914 4.03492 7.75965 3.93944 8 3.93944C8.24035 3.93944 8.47086 4.03492 8.64082 4.20488C8.81077 4.37483 8.90625 4.60534 8.90625 4.84569C8.90625 5.08604 8.81077 5.31655 8.64082 5.48651C8.47086 5.65646 8.24035 5.75194 8 5.75194Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhushi);
export default __webpack_public_path__ + "static/media/zhushi .69d954c9b57b513aae7ca9976d641fe3.svg";
export { ForwardRef as ReactComponent };